import axios from "axios";
import { useLogouReduxHooks } from "./useAxiosHooks";
import { handleLogoutRedux } from "../../redux/actions/userAction";
import { store } from "../../redux/store";

const instance = axios.create({
  // baseURL: "http://localhost:9091/",
  baseURL: "/",
  timeout: 1000 * 60,
  // headers: {
  //   "Content-Type": "application/json",
  //   Authorization:
  //     "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc0dvZE1vZGUiOmZhbHNlLCJ1c2VySWQiOiI2NGVlZjIyODhmNmM3OTM0MzVkMjA0OTMiLCJ1c2VyTmFtZSI6Ijg0ODI0NTgwNjkwLUlFTFRTIiwiaXNWZXJpZmllZCI6dHJ1ZSwiRGlzcGxheU5hbWUiOiI4NDgyNDU4MDY5MCIsIlByb3ZpbmNlSWQiOi0xLCJEaXN0cmljdElkIjotMSwiUGhvbmVOdW1iZXIiOiI4NDgyNDU4MDY5MCIsIlNjaG9vbFllYXIiOjIwMjMsImNvZGVBcHAiOiJBUFBFTkdMSVNISUVMVFMiLCJSb2xlIjoiU1RVREVOVCIsIkdlbmRlciI6Ik5BTSIsIkNyZWF0ZUJ5U2Nob29sIjotMSwicHJlbWl1bSI6ZmFsc2UsImNhbkNoYW5nZVBhc3N3b3JkIjp0cnVlLCJzdHVkZW50SWQiOiJPTkxVWUVOIElFTFRTIiwicGFja2FnZXMiOlsiSUVMQjJDMTIzNE41IiwiSUVMSlVOMTIiLCJJRUxPVkVSVklFVyJdLCJqdGkiOiI4MjM4MDQ5Zi04Yzc3LTQ1ZTMtOWJhZi1kZDg1ZWVjMDBmNmIiLCJpYXQiOjE3MTQwMTE0MDEsIm5iZiI6MTcxNDAxMTQwMSwiZXhwIjoxNzE2NjAzNDAxLCJpc3MiOiJFRE1JQ1JPIiwiYXVkIjoiT05MVVlFTi5WTiJ9.1lSr-cMUzsDKxca7T5sLg-UOlRoVh9DHfDjE_yU1xcA",
  // },
  withCredentials: true,
});

// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    const token = store.getState().user.account.token;
    if (token) {
      config.headers.authen = token;
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// // Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    const { errorCode } = response.data;
    console.log("===>response.data:", response.data);
    if (errorCode === 401) {
      // return Promise.reject("401");
      // dispatch(handleLogoutRedux());
    }
    return response.data;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    console.log("===>Error:", error);
    return Promise.reject(error);
  }
);
const getTokenInCookie = () => {
  // let data = sessionStorage.getItem("account");
  // if (data) {
  //   const json = JSON.parse(data);
  //   // console.log("getTokenInCookie", json.token);
  //   return json.token || "";
  // }
  return "";
};

export default instance;
